import { render, staticRenderFns } from "./GameStarted.vue?vue&type=template&id=1a77072c&scoped=true&"
import script from "./GameStarted.vue?vue&type=script&lang=js&"
export * from "./GameStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77072c",
  null
  
)

export default component.exports